const Form052EN = {
    stepName: {
        schoolInfor: "School Information",
        partA: "Part A: Claim for cash grant for auxiliary staff",
        partB: "Part B: Declaration",
        confirmation: "Confirmation",
    },
    errorMsg: {
        shorter:
            "Freeze period of the vacant post(s) should not shorter than 30 days",
        laterThanDate:
            "The Date cannot be later than or earlier than 31 Aug of the subject school year",
    },
    label: {
        statement: "Personal Information Collection Statement",
        read: "I have read, understood and agreed to the above terms and conditions",
        read2: 'I understand the applicant and the teacher need to have an "iAM Smart+" account to process the application.',
        // ssdo: "Senior School Development Officer",
        ssdo: "SSDO",
        schoolYear: "School Year",
        schoolName: "School Name",
        schoolCode: "School Code",
        cashGrant: "Claim for cash grant for auxiliary staff",
        vacant: "We would like to temporarily freeze the vacant post(s) of",
        applyTitle: "Please Select Section",
        approved:
            "on the approved establishment in exchange for cash grant for auxiliary staff.",
        postNumber: "Number of vacant post(s) in exchange for {{cash}} (a)",
        claim: "N: New claim post/ R: Revised claim",
        previousClaim:
            "Unchange previous claim/Delete previous claim/Change previous claim",
        previousClaimNumber:
            "Please indicate the application number of previous claim form",
        errorPreNum: "application number of previous claim form",
        fromDate: "Freeze period of the vacant post(s) From (dd/mm/yyyy)",
        toDate: "Freeze period of the vacant post(s) To (dd/mm/yyyy)",
        qualifiedNumber: "Number of Qualified Months",
        salary: "Monthly Salary",
        subsidy: "MPF Subsidy",
        mpfAttachment: "MPF Supporting Information",
        amount: "Amount of {{cash}}",
        previousClaimDated: "Copy of previous claim dated",
        previousClaimAttachment: "Attachment for previous claim",
        declaration: "I certify that –",
        establishment: "Number of establishment of {{name}}",
        vacancy: "Vacancy(ies) for {{name}}",
        fileReference: "File reference of approval from EDB",
        colon: "; ",
        space: " ",
        supervisorName: "Name of Supervisor",
        date: "Date",
        contactPerson: "Contact Person",
        telNo: "Tel No.",
        ssdo1: "To: Respective Regional Education Office【Attn: (",
        ssdo2: ")】",
    },
    sectionOption: {
        School: "School Section",
        Boarding: "Boarding Section",
    },
    cashValue: {
        TeacherAssistant: "Teacher assistant",
        Cook: "Cook",
        SchoolBusDriver: "Special driver",
        Watchman: "Watchman",
    },
    postValue: {
        TeacherAssistant: "Teacher Assistant",
        Cook: "Cook",
        SchoolBusDriver: "School Bus Drivers",
        Watchman: "Watchman",
    },
    post1Value: {
        teacherAssistant: "Teacher Assistant",
        cook: "Cook",
        specialDriver: "Special Driver",
        watchman: "Watchman",
    },
    sectionValue: {
        TeacherAssistant: "Cash Grant for Teacher Assistant",
        Cook: "Cash Grant for Cook",
        SchoolBusDriver: "Cash Grant for School Bus Driver",
        Watchman: "Cash Grant for Watchman",
    },
    claimValue: { N: "N: New claim post", R: "R: Revised claim" },
    previousClaimValue: {
        unchange: "Unchange previous claim",
        delete: "Delete previous claim",
        change: "Change previous claim",
    },
    salaryValue: {
        pt4: "16565",
        pt7: "20035",
        pt8: "21340",
        pt9: "22725",
    },

    sSDOValue: {
        0: "North District",
        1: "Kwai Chung & Tsing Yi District",
        2: "Sai Kung District",
        3: "Hong Kong East District",
        4: "Tuen Mun District",
        5: "Kowloon City District",
        6: "Kwun Tong District",
        7: "Southern District",
        8: "Yau Tsim & Mong Kok District",
        9: "Tsuen Wan District",
        10: "Sha Tin District",
        11: "Sham Shui Po District",
        12: "Tai Po District",
        13: "Wan Chai District",
        14: "Islands District",
        15: "Central & Western District",
        16: "Yuen Long District",
        17: "Wong Tai Sin District",
    },
    note1: [
        {
            text: "1. Calculate the number of qualified months from the starting date to the ending date (both dates inclusive) for cash grant for auxiliary staff by adding up the following 3 elements:",
        },
        {
            text: "(i) the number of qualified days as a proportion of the total number of calendar days in the starting month of the period (if applicable);",
        },
        {
            text: "(ii)	the number of full calendar months (if applicable); and",
        },
        {
            text: "(iii) the number of qualified days as a proportion of the total number of calendar days in the ending month of the period (if applicable).",
        },
        {
            text: "Example:",
        },
        {
            text: "Assuming that the qualified period for cash grant for auxiliary staff starts from 5 February to 26 May, the number of qualified months should be calculated as follows:",
        },
        {
            text: "(i) 24 being the number of qualified days in the starting month (5 to 28 February) divided by 28 (the total number of calendar days in February) = 0.857 month;",
        },
        {
            text: "(ii) 2 full calendar months from March to April;",
        },
        {
            text: "(iii) 26 being the number of qualified days in the ending month (1 to 26 May) divided by 31 (the total number of calendar days in May) = 0.839 month.",
        },
        {
            text: "Therefore, the number of qualified months is the sum of the above 3 elements (rounded to 3 decimal places), i.e. 0.857 + 2 + 0.839 = 3.696 (months).",
        },
    ],
    note2: [
        {
            text: "2. Please specify the mid-point salary of the post(s) concerned.  The mid-point salary of the auxiliary staff concerned is set out in Education Bureau (EDB) Circular No. 5/2021 and is tabulated as follows:",
        },
        {
            text: "Please refer to EDB Circular No. 5/2021 for the use of various cash grants for auxiliary staff and the relevant administrative arrangement.",
        },
    ],
    note2Row: {
        post: "Post",
        salary: "Mid-point salary",
    },
    note2Cell: {
        teacherAssistant: "Teacher Assistant",
        cook: "Cook",
        specialDriver: "Special Driver",
        watchman: "Watchman",
    },
    note2Value: [
        { text: "Point 4 of Model Scale 1 Pay Scale" },
        { text: "Point 7 of Master Pay Scale" },
        { text: "Point 9 of Master Pay Scale" },
        { text: "Point 8 of Model Scale 1 Pay Scale" },
    ],
    note3: "3. If the qualified period reaches 60 days or more, cash grant for auxiliary staff will cover the employer’s contributions to the MPF (5% of the monthly salary and capped at the maximum amount stipulated under the prevailing MPF regulations), which is rounded off to 2 decimal places.  For encashment for a period of less than 60 calendar days for freezing for vacant posts, and the contribution to MPF Schemes is required, please provide supporting information.",
    note4: "4. Amounts are rounded off to 2 decimal places after each multiplication.",
    note5: "Not shorter than 30 days",
    lableStep: [
        { step: "(i)" },
        { step: "(ii)" },
        { step: "(iii)" },
        { step: "(iv)" },
        { step: "(v)" },
    ],
    certify: {
        note1: "consent has been obtained from the Incorporated Management Committee and the majority of",
        note2: "of our school for freezing the above post(s) during the aforesaid period in the school year;",
        note3: " the claim for the frozen post(s) of",
        note4: "post(s) under Part A in exchange for cash grant for auxiliary staff is justified because such post(s) remain(s) vacant on the approved establishment during the aforesaid period and the eligibility criteria for conversion into cash grant for auxiliary staff have been met;",
        note5: "the number of frozen post(s) in exchange for cash grant for auxiliary staff in the aforesaid period does not exceed that of the approved staff establishment of our school in the aforesaid period (file reference of approval from EDB:",
        note6: ", number of establishment of",
        note7: "). There is/are vacancy(ies) for the above auxiliary staff post(s) (vacancy(ies) for",
        note8: ") in our school. The corresponding number of vacancy(ies) will be offset as the relevant post(s) is/are frozen;",
        note9: " no duplicate claim for other government subventions on account of the vacancy(ies) set out in Part A above has been made by our school; and",
        note10: " I understand the above cash grant for auxiliary staff arrangement aims at according greater flexibility to schools in staff appointment to meet school operation and student needs.",
        note11: "I confirm that the information stated in this form is correct.",
        note12: "Our school will refund to the EDB any overpayment of grant.",
    },
};
export default Form052EN;
